export default __webpack_public_path__ + "static/media/icon-delete.6955cd0e.svg";